import { apiResourceUrl } from "@ploy-lib/core";
import { ApplicationResource } from "./ApplicationResource";
import { BaseResource } from "./BaseResource";
export var AMLRisk;
(function (AMLRisk) {
    AMLRisk["NoContact"] = "NoContact";
    AMLRisk["NotSet"] = "NotSet";
    AMLRisk["Low"] = "Low";
    AMLRisk["Medium"] = "Medium";
    AMLRisk["High"] = "High";
})(AMLRisk || (AMLRisk = {}));
export var CustomerAMLRole;
(function (CustomerAMLRole) {
    CustomerAMLRole["NotSet"] = "NotSet";
    CustomerAMLRole["Customer"] = "Customer";
    CustomerAMLRole["CoSigner"] = "CoSigner";
    CustomerAMLRole["BeneficialOwner"] = "BeneficialOwner";
    CustomerAMLRole["Dagligleder"] = "Dagligleder";
    CustomerAMLRole["Nestleder"] = "Nestleder";
    CustomerAMLRole["Obervat\u00F8r"] = "Observat\u00F8r";
    CustomerAMLRole["Styremedlem"] = "Styremedlem";
    CustomerAMLRole["Styretsleder"] = "Styretsleder";
    CustomerAMLRole["Varamedlem"] = "Varamedlem";
    CustomerAMLRole["Kontaktperson"] = "Kontaktperson";
    CustomerAMLRole["Fullmaktshaver"] = "Fullmaktshaver";
    CustomerAMLRole["Unknown"] = "Unknown";
})(CustomerAMLRole || (CustomerAMLRole = {}));
export class ApplicationAMLRisksResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.totalRisk = AMLRisk.NotSet;
        this.customerAMLResults = [];
        this.riskResults = [];
    }
    pk() {
        return this.id?.toString();
    }
    static url(allParams = {}) {
        const { applicationNumber, customerId } = allParams;
        if (applicationNumber !== undefined) {
            if (customerId !== undefined) {
                return `${ApplicationResource.urlRoot}/${applicationNumber}/aml-risk?customerId=${customerId}`;
            }
            else {
                return `${ApplicationResource.urlRoot}/${applicationNumber}/aml-risk`;
            }
        }
        else {
            throw new Error("ApplicationAMLRisksResource requires applicationNumber");
        }
    }
}
// static indexes = ["applicationNumber"];
ApplicationAMLRisksResource.urlTemplates = [
    `${ApplicationResource.urlRoot}/{applicationNumber}/aml-risk`
];
ApplicationAMLRisksResource.urlRoot = apiResourceUrl("aml-risks");
export class ApplicationAMLRiskHistoryResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.risk = AMLRisk.NotSet;
        this.comment = "";
        this.timestamp = "";
    }
    pk() {
        return this.id?.toString();
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            pollFrequency: 60 * 1000,
            dataExpiryLength: 30 * 1000
        };
    }
}
ApplicationAMLRiskHistoryResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/history`);
ApplicationAMLRiskHistoryResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{amlRiskId}/history`;
export class ApplicationAMLRiskCustomerResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            pollFrequency: 60 * 1000,
            dataExpiryLength: 30 * 1000
        };
    }
}
ApplicationAMLRiskCustomerResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/customer`);
ApplicationAMLRiskCustomerResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{applicationNumber}/customer`;
export class ApplicationAMLRiskCommentResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.comment = "";
        this.timestamp = "";
    }
    pk() {
        return this.id?.toString();
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            pollFrequency: 60 * 1000,
            dataExpiryLength: 30 * 1000
        };
    }
}
ApplicationAMLRiskCommentResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/comment`);
ApplicationAMLRiskCommentResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{applicationNumber}/comment`;
export class ApplicationAMLRiskClassificationResultResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
    static fromJS(data) {
        if (!data || data.id === undefined) {
            const emptyValue = { id: -1, value: -1 };
            return super.fromJS({ ...new this(), ...emptyValue });
        }
        return super.fromJS(data);
    }
}
ApplicationAMLRiskClassificationResultResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/policy-rules/result`);
ApplicationAMLRiskClassificationResultResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{amlRiskId}/policy-rules/result`;
export class ApplicationAMLRiskPolicyRulesResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
}
ApplicationAMLRiskPolicyRulesResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/policy-rules`);
ApplicationAMLRiskPolicyRulesResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{amlRiskId}/policy-rules`;
export class ApplicationAMLOverrideResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
    static fromJS(data) {
        if (!data || data.id === undefined) {
            const emptyValue = {
                id: -1,
                userFullName: "",
                previousTotalRisk: -1,
                newTotalRisk: -1,
                comment: "",
                timestamp: ""
            };
            return super.fromJS({ ...new this(), ...emptyValue });
        }
        return super.fromJS(data);
    }
}
ApplicationAMLOverrideResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/rc-override`);
ApplicationAMLOverrideResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{amlRiskId}/rc-override`;
export class ApplicationAMLOverrideHistoryResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
}
ApplicationAMLOverrideHistoryResource.urlTemplates = ApplicationAMLRisksResource.urlTemplates.map(r => `${r}/rc-override/all`);
ApplicationAMLOverrideHistoryResource.urlRoot = `${ApplicationAMLRisksResource.urlRoot}/{amlRiskId}/rc-override/all`;
//# sourceMappingURL=ApplicationRiskResource.js.map